export const FEED_CONSTANTS = {
    DRAG_THRESHOLD: 0.25,
    WHEEL_DEBOUNCE_MS: 150,
    MOUNT_TRANSITION_DELAY_MS: 100,
    TRANSITION_DURATION_MS: 300,
    TRANSITION_EASING: 'cubic-bezier(0.4, 0, 0.2, 1)',
    LOAD_MORE_BUFFER: 2,
    VIRTUAL_WINDOW_SIZE: 3,
}

export const NAVIGATION_DIRECTION = {
    NEXT: 'next',
    PREV: 'prev',
}

export const POST_POSITION = {
    PREVIOUS: 'prev',
    CURRENT: 'current',
    NEXT: 'next',
}

export const RESOURCE_TYPE = {
    POST: 'post',
    AD: 'ad',
}
